module.exports = __webpack_public_path__ + "static/img/ux_head.d3feac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/ux_head.png
// module id = lyKd
// module chunks = 25